<template>
    <svg id="vaccine" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 16.802 16.802">
        <path id="Path_70115" data-name="Path 70115"
              d="M13.924,3.575,16.8.7,16.1,0,13.227,2.878,12.4,2.049,11.032,3.415l-.383-.383-6.5,6.5a1.01,1.01,0,0,1-1.429,0l-.7.7.874.874L1.178,12.822.7,12.342l-.7.7L3.763,16.8l.7-.7-.481-.481L5.7,13.907l.874.874.7-.7h0a1.01,1.01,0,0,1,0-1.428l6.5-6.5-.383-.383L14.753,4.4ZM3.283,14.927,1.875,13.519,3.592,11.8,5,13.21Zm3.288-2.969a1.985,1.985,0,0,0-.521.908L3.936,10.752a1.985,1.985,0,0,0,.908-.521l.032-.032.863.863.7-.7L5.573,9.5l.746-.746.863.863.7-.7-.863-.863.746-.746.863.863.7-.7L8.46,6.616l.746-.746.863.863.7-.7L9.9,5.172l.746-.746,1.727,1.727Zm5.158-7.846.669-.669.961.961-.669.669Z"
              transform="translate(0)" fill="#fff"/>
    </svg>

</template>

<script>
    export default {
        name: "INeedle",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
